import { useQuery } from "@tanstack/react-query";
import { http } from "../../../utils";

export async function fetchFAQById(id) {
  const { data } = await http(`/admin/faqs/${id}`);

  return data;
}

export function useFAQById(id) {
  const { data, ...raResult } = useQuery(["faq-detail", id], () =>
    fetchFAQById(id)
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}
